import { useQueryClient } from '@tanstack/react-query';
import { useNotifier } from '@provider/notifier';
import { useUserIdentityState } from '@provider/user-identity';
import { IconButton, TrashIcon } from '@ui/kit';
import { useDeleteTeamMutation } from './api.delete-team.mutation.js';
import { jsx } from 'react/jsx-runtime';
import { getComponentEntriesQuery } from '../../component-entries/api/query.get-component-entries.js';
import { componentEntryStore } from '../../component-entries/state.js';

function DeleteTeamAction(props) {
  const del = useDeleteTeamMutation();
  const queryClient = useQueryClient();
  const notifier = useNotifier();
  const user = useUserIdentityState(state => state.user);
  return /*#__PURE__*/jsx(IconButton, {
    icon: /*#__PURE__*/jsx(TrashIcon, {}),
    label: "Slet hold",
    onClick: async evt => {
      evt.stopPropagation();
      const confirmed = await notifier.confirm({
        heading: "Vil du slette holdet?",
        body: "Hvis du sletter holdet, vil du ikke længere kunne tilgå de besvarelser elever på dette hold har delt med dig.",
        labels: {
          ok: "Slet"
        }
      });
      if (confirmed !== "ok") {
        return;
      }
      await del.mutateAsync(props.team);

      // Ensure we refetch all notifications after creating a new team as they
      // may trigger additional notifcations
      queryClient.refetchQueries(getComponentEntriesQuery(user, componentEntryStore.getState().filters.timespan));
    }
  });
}

export { DeleteTeamAction };
//# sourceMappingURL=action.delete-team.js.map
